import { createSelector } from 'reselect';

const constructionSelector = (state) => state.Construction;

export default createSelector(
  constructionSelector,
  (construction) => ({
    loaded: construction.parameters_loaded,

    // BACK
    shutter_back_count_available: [...(construction.available.shutter_back_count || [])],
    shutter_back_count_info: construction.info.shutter_back_count,
    shutter_back_count_selected: construction.selected.shutter_back_count,
    shutter_back_size_available: [...(construction.available.shutter_back_size || [])],
    shutter_back_size_info: construction.info.shutter_back_size,
    shutter_back_size_selected: construction.selected.shutter_back_size,
    shutter_back_material_available: [...(construction.available.shutter_back_material || [])],
    shutter_back_material_info: construction.info.shutter_back_material,
    shutter_back_material_selected: construction.selected.shutter_back_material,

    // FRONT ✅ DODANE
    shutter_front_count_available: [...(construction.available.shutter_front_count || [])],
    shutter_front_count_info: construction.info.shutter_front_count,
    shutter_front_count_selected: construction.selected.shutter_front_count,
    shutter_front_size_available: [...(construction.available.shutter_front_size || [])],
    shutter_front_size_info: construction.info.shutter_front_size,
    shutter_front_size_selected: construction.selected.shutter_front_size,
    shutter_front_material_available: [...(construction.available.shutter_front_material || [])],
    shutter_front_material_info: construction.info.shutter_front_material,
    shutter_front_material_selected: construction.selected.shutter_front_material,

    // LEFT
    shutter_left_count_available: [...(construction.available.shutter_left_count || [])],
    shutter_left_count_info: construction.info.shutter_left_count,
    shutter_left_count_selected: construction.selected.shutter_left_count,
    shutter_left_size_available: [...(construction.available.shutter_left_size || [])],
    shutter_left_size_info: construction.info.shutter_left_size,
    shutter_left_size_selected: construction.selected.shutter_left_size,
    shutter_left_material_available: [...(construction.available.shutter_left_material || [])],
    shutter_left_material_info: construction.info.shutter_left_material,
    shutter_left_material_selected: construction.selected.shutter_left_material,

    // RIGHT
    shutter_right_count_available: [...(construction.available.shutter_right_count || [])],
    shutter_right_count_info: construction.info.shutter_right_count,
    shutter_right_count_selected: construction.selected.shutter_right_count,
    shutter_right_size_available: [...(construction.available.shutter_right_size || [])],
    shutter_right_size_info: construction.info.shutter_right_size,
    shutter_right_size_selected: construction.selected.shutter_right_size,
    shutter_right_material_available: [...(construction.available.shutter_right_material || [])],
    shutter_right_material_info: construction.info.shutter_right_material,
    shutter_right_material_selected: construction.selected.shutter_right_material
  })
);
